import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './Team.css';
import { FaLinkedin, FaInstagram, FaGithub } from 'react-icons/fa';
 
import chair from '../assets/team/chair.png';
import vicechair from '../assets/team/vicechair.png';
import secretary from '../assets/team/secretary.png';
import treasurer from '../assets/team/treasurer.png';
import webmaster from '../assets/team/webmaster.png';
import membershipchair from '../assets/team/membershipchair.png';

import member1 from '../assets/team/member1.jpg';
import member2 from '../assets/team/member2.jpg';
import member3 from '../assets/team/member3.jpg';
import member4 from '../assets/team/member4.jpg';
import member5 from '../assets/team/member5.jpg';
import member6 from '../assets/team/member6.jpg';
import member7 from '../assets/team/member7.jpg';
import member8 from '../assets/team/member8.jpg';
import member9 from '../assets/team/member9.jpg';
import member10 from '../assets/team/member10.jpg';
import member11 from '../assets/team/member11.jpg';
import member12 from '../assets/team/member12.jpg';
import member13 from '../assets/team/member13.jpg';
import member14 from '../assets/team/member14.jpg';

const allTeamMembers = [
  // Core Team Members
  { id: 1, name: 'Mr. Prem Rahangdale', role: 'Chairperson', photo: chair, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/prem-rahangdale-1b5375246/', instagram: 'https://www.instagram.com/prem789k/', github: 'https://github.com/prem789k-coder' } },
  { id: 2, name: 'Mr. Tejas Choudhari', role: 'Vice Chairperson', photo: vicechair, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/tejas-choudhari-99a706342/', instagram: 'https://www.instagram.com/tejas_446/', github: '#' } },
  { id: 3, name: 'Mr. Ritesh Dhakulkar', role: 'Secretary', photo: secretary, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/riteshdhakulkar/', instagram: 'https://www.instagram.com/riteshhd_/', github: '#' } },
  { id: 4, name: 'Ms. Mansi Katre', role: 'Treasurer', photo: treasurer, category: 'Core Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 5, name: 'Ms. Kanak Patle', role: 'Webmaster', photo: webmaster, category: 'Core Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 6, name: 'Ms. Sayalee Nichante', role: 'Membership-Chair', photo: membershipchair, category: 'Core Team', social: { linkedin: '#', instagram: '#', github: '#' } },

  // Heads & Members
  { id: 7, name: 'Mr. Pralhad Kadu', role: 'Member', photo: member1, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 8, name: 'Mr. Ishank Ikhare', role: 'Member', photo: member2, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 9, name: 'Mr. Anuj Dalal', role: 'Member', photo: member3, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 10, name: 'Mr. Raunak Moundekar', role: 'Member', photo: member4, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 11, name: 'Ms. Sejal Lale', role: 'Member', photo: member5, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 12, name: 'Ms. Sanika Karamkar', role: 'Member', photo: member6, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 13, name: 'Mr. Druv Randive', role: 'Member', photo: member7, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 14, name: 'Mr. Om Hatwar', role: 'Member', photo: member8, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 15, name: 'Mr. Pratham Sahu', role: 'Member', photo: member9, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 16, name: 'Mr. Ritik Nagpure', role: 'Member', photo: member10, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 17, name: 'Mr. Atharva Meshram', role: 'Member', photo: member11, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 18, name: 'Ms. Sanika Pachpile', role: 'Member', photo: member12, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 19, name: 'Ms. Ridhima Kohad', role: 'Member', photo: member13, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 20, name: 'Ms. Aditi Pikalmunde', role: 'Member', photo: member14, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } }
];


// This is a reusable card component for a single team member.
const TeamMemberCard = ({ member }) => (
  <div className="team-card">
    <img src={member.photo} alt={member.name} className="member-photo" />
    <h3 className="member-name">{member.name}</h3>
    <p className="member-position">{member.role}</p>
    <div className="social-links">
      {member.social.linkedin && member.social.linkedin !== '#' && (
        <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
      )}
      {member.social.instagram && member.social.instagram !== '#' && (
        <a href={member.social.instagram} target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
      )}
      {member.social.github && member.social.github !== '#' && (
        <a href={member.social.github} target="_blank" rel="noopener noreferrer"><FaGithub /></a>
      )}
    </div>
  </div>
);

const Team = () => {
  // Get the category from the URL (e.g., 'core-team' or 'web-team')
  const { teamCategory } = useParams();

  const [filteredMembers, setFilteredMembers] = useState([]);
  const [title, setTitle] = useState('Core Team');

  // This effect runs when the page loads or when the URL category changes.
  useEffect(() => {
    let membersToDisplay = [];
    let newTitle = '';

    if (teamCategory === 'web-team') {
      newTitle = 'Heads & Members';
      membersToDisplay = allTeamMembers.filter(member => member.category === 'Web Team');
    } else {
      // Default to 'Office Bearers' for any other URL, including /team and /team/core-team
      newTitle = 'Office Bearers';
      membersToDisplay = allTeamMembers.filter(member => member.category === 'Core Team');
    }

    setTitle(newTitle);
    setFilteredMembers(membersToDisplay);
  }, [teamCategory]); // This dependency array ensures the code re-runs when the URL changes.

  return (
    <div className="section-container">
      <h2 className="section-title">{title}</h2>
      <div className="team-grid">
        {filteredMembers.map((member) => (
          <TeamMemberCard key={member.id} member={member} />
        ))}
      </div>
    </div>
  );
};

export default Team;
